import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kd-animation-emoji-suprise',
  templateUrl: './animation-emoji-suprise.component.html',
  styleUrls: ['./animation-emoji-suprise.component.scss']
})
export class AnimationEmojiSupriseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
